import { render, staticRenderFns } from "./11c_doc.vue?vue&type=template&id=05a37608&scoped=true"
import script from "./11c_doc.vue?vue&type=script&lang=js"
export * from "./11c_doc.vue?vue&type=script&lang=js"
import style0 from "./11c_doc.vue?vue&type=style&index=0&id=05a37608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a37608",
  null
  
)

export default component.exports